import { connect, type ConnectedProps } from "react-redux";
import { EmailSettings } from "./EmailSettings";
import { type AppDispatch, type RootState } from "features/Application/globaltypes/redux";
import { bindAction } from "interfaces";

import {
  deleteEmailSettings,
  fetchEmailSettings,
  upsertEmailSettings,
  verifyEmailSettings,
} from "./state/thunks/emailSettingsThunk";
import { type SystemNotificationSetting, type EmailSetting } from "../types";
import { emailSettingsSelector } from "./state/slices/emailSettingsSlice";
import { permissionsToAccountSelector } from "../EditAccount/state/slices/permissionsToAccountSlice";
import {
  fetchSystemNotificationSettings,
  updateSystemNotificationSetting,
} from "./state/thunks/systemNotificationSettingsThunk";
import { systemNotificationSettingsSelector } from "./state/slices/systemNotificationSettingsSlice";

export type EmailSettingsPropsAll = EmailSettingsProps & PropsFromRedux;

export interface EmailSettingsProps {
  accountId: number;
}

type PropsFromRedux = ConnectedProps<typeof connector>;

/* istanbul ignore next */
const mapStateToProps = (state: RootState) => {
  const emailSettings = emailSettingsSelector(state);
  const systemNotificationSettings = systemNotificationSettingsSelector(state);

  return {
    currentConfiguration: emailSettings.settings,
    isLoading: emailSettings.isLoading || systemNotificationSettings.isLoading,
    accountOnEditPermissions: permissionsToAccountSelector(state),
    error: emailSettings.error?.message,
    systemNotificationSettings: systemNotificationSettings.settings,
  };
};

/* istanbul ignore next */
const mapDispatchToProps = (dispatch: AppDispatch, ownProps: EmailSettingsProps) => ({
  getEmailSettings: () => dispatch(fetchEmailSettings(ownProps.accountId)),
  saveEmailSettings: (emailSettings: EmailSetting) => {
    emailSettings.accountId = ownProps.accountId;
    return dispatch(upsertEmailSettings(emailSettings));
  },
  deleteEmailSettings: () => dispatch(deleteEmailSettings(ownProps.accountId)),
  verifyEmailSettings: bindAction(verifyEmailSettings, dispatch),
  getSystemNotificationSettings: () => dispatch(fetchSystemNotificationSettings(ownProps.accountId)),
  updateSystemNotificationSetting: (setting: SystemNotificationSetting) =>
    dispatch(updateSystemNotificationSetting(ownProps.accountId, setting)),
});

const connector = connect(mapStateToProps, mapDispatchToProps);
const EmailSettingsContainer = connector(EmailSettings as (props: EmailSettingsPropsAll) => React.ReactElement);
export default EmailSettingsContainer;
